import { CBU } from '@/interfaces/cbu';
import { queryCBU } from '@/services/cbu.service';
import { Effect, Reducer } from '@umijs/max';
import { redirectNotFound } from '@/utils/errorRedirect';

export interface ModelType {
  namespace: string;
  state: { cbu: null | CBU };
  effects: {
    sendHistory: Effect;
    fetchCBUDetail: Effect;
  };
  reducers: {
    setCBU: Reducer<any>;
    setHistory: Reducer<any>;
  };
}

const Model: ModelType = {
  namespace: 'cbuDetail',

  state: {
    cbu: null,
  },

  effects: {
    *fetchCBUDetail({ payload }, { call, put, all }) {
      try {
        const [cbu] = yield all([call(queryCBU, payload)]);
  
        yield put({
          type: 'setCBU',
          payload: { cbu: cbu.data },
        });
      } catch (error) {
        redirectNotFound(error);
      }
    },

    *sendHistory({ payload }) {
      yield {
        type: 'setHistory',
        payload,
      };
    },
  },

  reducers: {
    setCBU(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },

    setHistory(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};

export default Model;
